import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';

// Environment
import { environment } from '../../../environments/environment';

// Models
import { Faq } from '../models/faq';


@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private readonly _faqList = toSignal(
    inject(HttpClient).get<Faq[]>(`${environment.apiGatewayUrl}/monitoring/api/v1/faqs`),
    { initialValue: [] }
  );

  readonly faqList = this._faqList;
}
